<!-- Receipt print template -->
@if (receiptDetail) {
  <div class="printable-screen py-4" #printTemplate>
    <div class="w-100 text-center mb-4">
      <img src="/assets/images/logo.png" style="max-height: 60px;" alt="Monek Logo" />
    </div>

    @if (receiptDetail.transactionName) {
      <h1 class="w-100 text-center fs-3 mb-4 text-decoration-underline">{{ receiptDetail.transactionName }}</h1>
    }
    
    <div class="text-center mb-4">
      <h5 class="mb-1 pt-2">Thank you for your purchase</h5>
      <h3 class="mb-0">
        Receipt for transaction: <b>{{ receiptDetail.traceId }}</b>
      </h3>
    </div>

    <table class="table table-striped">
      <thead>
        <tr>
          <th>Header</th>
          <th>Detail</th>
        </tr>
      </thead>
      <tbody>
        @if (receiptDetail.transactionType) {
          <tr>
            <td>Transaction Type</td>
            <td>{{ receiptDetail.transactionType }}</td>
          </tr>
        }
        @if (receiptDetail.status) {
          <tr>
            <td>Status</td>
            <td>{{ receiptDetail.status }}</td>
          </tr>
        }
        @if (receiptDetail.custName) {
          <tr>
            <td>Cardholder Name</td>
            <td>{{ receiptDetail.custName }}</td>
          </tr>
        }
        @if (receiptDetail.custPostcode) {
          <tr>
            <td>Cardholder Postcode</td>
            <td>{{ receiptDetail.custPostcode }}</td>
          </tr>
        }
        @if (receiptDetail.custEmail) {
          <tr>
            <td>Cardholder Email</td>
            <td>{{ receiptDetail.custEmail }}</td>
          </tr>
        }
        @if (receiptDetail.maskedCard) {
          <tr>
            <td>Card Number</td>
            <td>{{ receiptDetail.maskedCard }}</td>
          </tr>
        }
        @if (receiptDetail.detail) {
          <tr>
            <td>Payment Description</td>
            <td>
              <i>{{ receiptDetail.detail }}</i>
            </td>
          </tr>
        }
        @if (receiptDetail.paymentReference) {
          <tr>
            <td>Payment Reference</td>
            <td>{{ receiptDetail.paymentReference }}</td>
          </tr>
        }
        @if (receiptDetail.operatorName) {
          <tr>
            <td>Operator</td>
            <td>{{ receiptDetail.operatorName }}</td>
          </tr>
        }
        <tr>
          <td>Date Completed</td>
          <td>{{ receiptDetail.time | date: 'dd/MM/yy HH:mm' }}</td>
        </tr>
        @if (receiptDetail.authCode) {
          <tr>
            <td>Authorisation Code</td>
            <td>{{ receiptDetail.authCode }}</td>
          </tr>
        }
        <tr>
          <td>Total Amount</td>
          <td>
            <b>{{ receiptDetail.amount | currency: receiptDetail.currencyCode }}</b>
          </td>
        </tr>
        @if (receiptDetail.amountRefunded !== undefined && receiptDetail.amountRefunded > 0) {
          <tr>
            <td>Amount Refunded</td>
            <td class="text-danger">
              <b>{{ receiptDetail.amountRefunded | currency: receiptDetail.currencyCode }}</b>
            </td>
          </tr>
        }
        @if (receiptDetail.remainingValue !== undefined && receiptDetail.remainingValue !== receiptDetail.amount) {
          <tr>
            <td>Remaining Value</td>
            <td>
              <b>{{ receiptDetail.remainingValue | currency: receiptDetail.currencyCode }}</b>
            </td>
          </tr>
        }
      </tbody>
    </table>

    @if (receiptDetail.hasBasketData()) {
      <div class="mt-4">
        <h4 class="mb-2 border-bottom pb-2">Basket</h4>
        @if (receiptDetail.invoice?.invoiceNumber || receiptDetail.invoice?.orderNumber) {
          <p class="mb-2 small">
            @if (receiptDetail.invoice?.invoiceNumber) { <span>Invoice {{ receiptDetail.invoice?.invoiceNumber }}</span> }
            @if (receiptDetail.invoice?.invoiceNumber && receiptDetail.invoice?.orderNumber) { <span> &middot; </span> }
            @if (receiptDetail.invoice?.orderNumber) { <span>Order {{ receiptDetail.invoice?.orderNumber }}</span> }
          </p>
        }
        <table class="table table-sm table-striped basket-table">
          <thead>
            <tr>
              <th class="text-end">Qty</th>
              <th>Description</th>
              <th class="text-end">Unit</th>
              <th class="text-end">Total</th>
            </tr>
          </thead>
          <tbody>
            @for (item of receiptDetail.basketItems; track item) {
              <tr>
                <td class="text-end">{{ item.quantity }}</td>
                <td>
                  {{ item.description }}
                  @if (item.sku) { <small class="text-muted">({{ item.sku }})</small> }
                  @if (item.taxAmount !== undefined && item.taxAmount !== null) {
                    <div><small class="text-muted">{{ receiptDetail.taxLabel(item.taxCode, item.taxRate) }} {{ item.taxAmount | currency: receiptDetail.currencyCode }}</small></div>
                  }
                  @if (item.discountAmount) {
                    <div><small class="text-muted">Includes discount {{ item.discountAmount | currency: receiptDetail.currencyCode }}</small></div>
                  }
                </td>
                <td class="text-end">{{ item.unitPrice | currency: receiptDetail.currencyCode }}</td>
                <td class="text-end">{{ receiptDetail.lineTotal(item) | currency: receiptDetail.currencyCode }}</td>
              </tr>
            }
          </tbody>
          <tfoot>
            <tr>
              <td colspan="3" class="text-end">Subtotal</td>
              <td class="text-end">{{ receiptDetail.subtotal | currency: receiptDetail.currencyCode }}</td>
            </tr>
            @for (discount of receiptDetail.basketDiscounts; track discount) {
              <tr class="text-danger">
                <td colspan="3" class="text-end">
                  Discount: {{ discount.description || discount.code }}
                  @if (discount.rate) { <small>({{ discount.rate }}%)</small> }
                </td>
                <td class="text-end">-{{ discount.amount | currency: receiptDetail.currencyCode }}</td>
              </tr>
            }
            @if (receiptDetail.delivery; as delivery) {
              <tr>
                <td colspan="3" class="text-end">
                  Delivery: {{ delivery.carrier }}
                  @if (delivery.taxAmount !== undefined && delivery.taxAmount !== null) {
                    <small class="text-muted">(includes {{ delivery.taxAmount | currency: receiptDetail.currencyCode }} {{ receiptDetail.taxLabel(delivery.taxCode, delivery.taxRate) }})</small>
                  }
                </td>
                <td class="text-end">{{ delivery.amount | currency: receiptDetail.currencyCode }}</td>
              </tr>
            }
            @for (tax of receiptDetail.basketTaxes; track tax) {
              <tr>
                <td colspan="3" class="text-end">Tax: {{ tax.description || tax.code }} @if (tax.rate) { <small>({{ tax.rate }}%)</small> }</td>
                <td class="text-end">{{ tax.amount | currency: receiptDetail.currencyCode }}</td>
              </tr>
            }
            @if (receiptDetail.hasTaxDetail) {
              <tr>
                <td colspan="3" class="text-end"><small class="text-muted">Total tax ({{ receiptDetail.taxTypeLabel | lowercase }})</small></td>
                <td class="text-end"><small class="text-muted">{{ receiptDetail.taxTotal | currency: receiptDetail.currencyCode }}</small></td>
              </tr>
            }
            <tr class="fw-bold">
              <td colspan="3" class="text-end">Total paid</td>
              <td class="text-end">{{ receiptDetail.amount | currency: receiptDetail.currencyCode }}</td>
            </tr>
          </tfoot>
        </table>
        @if (receiptDetail.billingAddressLines.length) {
          <p class="small mb-2"><b>Bill to:</b> {{ receiptDetail.billingAddressLines.join(', ') }}</p>
        }
        @if (receiptDetail.deliveryAddressLines.length) {
          <p class="small mb-2"><b>Deliver to:</b> {{ receiptDetail.deliveryAddressLines.join(', ') }}</p>
        }
        @if (receiptDetail.hasTaxDetail) {
          <p class="text-end small text-muted mb-0 tax-summary">
            @for (line of receiptDetail.taxSummary; track line.label; let last = $last) {
              <span>{{ line.label }}: {{ line.amount | currency: receiptDetail.currencyCode }}</span>@if (!last) { <span> &middot; </span> }
            }
          </p>
        }
      </div>
    }
  </div>
}
